<template>
  <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')">

    <header class="widget-header">
      <h2 class="widget-title">{{ title }}</h2>
      <h3 class="widget-title-period">
        <span>Analyse sur toutes les années</span>
      </h3>

      <div class="widget-actions-container">
        <widget-dropdown v-model="type" :options="types" :callback="filterByType"></widget-dropdown>
      </div>

    </header>

    <div class="widget-preloader">
      <div class="pre-loader">
        <div class="box1"></div>
        <div class="box2"></div>
        <div class="box3"></div>
        <div class="box4"></div>
        <div class="box5"></div>
      </div>
    </div>

    <div class="widget-content" v-if="stats.dataset">

      <div class="widget-content-datas">
        <div class="data-labels">

          <div class="data-label">
            <strong>{{ total_customers }}</strong>
            <span class="legend">Total clients</span>
          </div>

          <div class="data-label">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ average_cart_ca|formatNumber }}</strong>
            <span class="legend">Panier moyen</span>
          </div>

          <div class="data-label">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ lifetime_value_ca|formatNumber }}</strong>
            <span class="legend">Lifetime Value CA</span>
          </div>

          <div class="data-label">
            <strong>{{ customer_retention_in_year }} ans</strong>
            <span class="legend">Cycle de vie moyen</span>
          </div>

          <div class="data-label">
            <strong>{{ customer_loyalty }} %</strong>
            <span class="legend">Taux de fidélisation moyen</span>
          </div>

        </div>
      </div>

      <div class="widget-chart" v-bind:class="{'active':stats.labels.length}" @click="setChartToFull">
        <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
      </div>
    </div>
  </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';
    import Chart from '../../../components/chart/Line.vue'

    export default {
      name: 'Widget',
      components: {
        'chart' : Chart
      },
      props: ['title','type','period','className','branch'],
      data () {
        return {
          types: [
            {id: 'all', label: 'Global'},
            {id: 'web', label: 'Web uniquement'},
            {id: 'direct', label: 'Direct uniquement'}
          ],
          periods: [
            {id: 'last_7days', label: '7 derniers jours'},
            {id: 'current_month', label: 'Ce mois'},
            {id: 'last_month', label: 'Le mois dernier'},
            {id: 'since_1_month', label: '30 derniers jours'},
            {id: 'since_3_months', label: '90 derniers jours'},
            {id: 'current_year', label: 'Cette année'},
            {id: 'last_year', label: 'Depuis 12 mois'},
            {id: 'all', label: 'Tout'},
            {id: 'custom', label: 'Personnalisé'},
          ],
          forceRefresh: null,
          loaded: false,
          stats: {
            dataset: null,
            labels: null
          },
          dateFilter: {
            start_at: '',
            end_at: '',
          },
          showAdvancedFilterVue: false,
          existing: null,
          isnew: null,
          currency: null,
          is_ttc: true,
          options: {
            __custom: {
              borderWidth: 0,
              transparentBackgroundTop: 0.6,
              transparentBackgroundBottom: 0.6
            },
            plugins: {
              labels: false
            },
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
                fontSize: 10,
                fontFamily: 'Gotham Rounded',
                fontWeight: 300
              }
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }
            },
            scales: {
              xAxes: [ {
                categoryPercentage: 1,
                barPercentage: 1,
                stacked: true,
                steppedLine: true,
                gridLines: {
                  offsetGridLines: false,
                  display: false,
                  color: "#eeeeee",
                  drawBorder: false
                },
                ticks: {
                  display: true,
                  fontColor: "#cccccc",
                  fontSize: 10,
                  mirror: false,
                  padding: 0,
                  align: 'start',
                  fontFamily: 'Gotham Rounded',
                  fontWeight: 300
                },
              }],
              yAxes: [
                  {
                    id: 'bar',
                    order: 1,
                    stacked: true,
                    steppedLine: true,
                    gridLines: {
                      offsetGridLines: true,
                      display: true,
                      color: "#eeeeee",
                      borderDashOffset: 1,
                      borderDash: [2,2],
                      drawBorder: false
                    },
                    ticks: {
                      fontColor: "#cccccc",
                      fontSize: 10,
                      display: true,
                      padding: 0,
                      fontFamily: 'Gotham Rounded',
                      fontWeight: 300
                      //stepSize: 1,
                      //suggestedMax: 0,
                      //suggestedMin: 0
                    }
                  },
                {
                  id: 'loyalty',
                  order: 1000,
                  stacked: false,
                  steppedLine: true,
                  position: 'right',
                  gridLines: {
                    offsetGridLines: true,
                    display: true,
                    color: "#eeeeee",
                    borderDashOffset: 1,
                    borderDash: [2,2],
                    drawBorder: false
                  },
                  ticks: {
                    fontColor: "#cccccc",
                    fontSize: 10,
                    display: true,
                    padding: 0,
                    fontFamily: 'Gotham Rounded',
                    fontWeight: 300,
                    stepSize: 10,
                    suggestedMax: 100,
                    suggestedMin: 0
                  }
                }
              ]
            }
          }
        }
      },
      mounted: function(){
        this.currency = this.$store.state.scope.currency_id
        this.is_ttc = this.$store.state.scope.is_ttc
        this.period = this.period ? this.period : this.periods[0].id

        if(this.period == 'custom') {
          this.showAdvancedFilterVue = true
        }else{
          this.showAdvancedFilterVue = false;
        }

        this.filterByPeriod(this.period);

      },
      watch: {
        'dateFilter.start_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.end_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        },
        'dateFilter.end_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.start_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        }
      },
      methods: {
        setChartToFull: function()
        {
          this.options.layout.padding = {
            left: -10,
            right: 0,
            top: 0,
            bottom: -10
          };
          this.options.scales.xAxes[0].ticks.display = true;
          this.options.scales.xAxes[0].gridLines.display = true;
          this.options.scales.yAxes[0].ticks.display = true;

        },
        filterByType: function(type)
        {
          this.type = type
          this.filterByPeriod(this.period)
        },
        filterByPeriod: function(period)
        {

          if(period == 'custom') {
            this.showAdvancedFilterVue = true
          }else{
            this.showAdvancedFilterVue = false;
          }

          if(period != 'custom') {

            this.loaded = false;
            this.period = period

            InvoiceService.getStatsAquisitionCohort( this.type, this.period, this.branch).then((response) => {
              this.stats.dataset = response.data.result.stats.dataset
              this.stats.labels = response.data.result.stats.labels

              this.customer_retention_in_year = response.data.result.customer_retention_in_year
              this.customer_loyalty = response.data.result.customer_loyalty
              this.lifetime_value_ca = response.data.result.lifetime_value_ca
              this.total_customers = response.data.result.total_customers
              this.average_cart_ca = response.data.result.average_cart_ca
              this.average_order_per_customer = response.data.result.average_order_per_customer

              this.loaded = true;
            }).catch((response) => {
              console.log("error", response);
              this.loaded = true;
            })

          }
        },
        filterByPeriodAndByDate: function(period, dateFilter)
        {
          this.loaded = false;

          this.period = period
          this.date = JSON.stringify(dateFilter);

          InvoiceService.getStatsAquisitionCohort( this.type, this.period, this.branch, this.date ).then((response) => {
            this.stats.dataset = response.data.result.stats.dataset
            this.stats.labels = response.data.result.stats.labels

            this.customer_retention_in_year = response.data.result.customer_retention_in_year
            this.customer_loyalty = response.data.result.customer_loyalty
            this.lifetime_value_ca = response.data.result.lifetime_value_ca
            this.total_customers = response.data.result.total_customers
            this.average_cart_ca = response.data.result.average_cart_ca
            this.average_order_per_customer = response.data.result.average_order_per_customer

            this.loaded = true;
          }).catch((response) => {
            console.log("error", response);
            this.loaded = true;
          })
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/StatsAquisitionCohortWidget.vue